import type { Dispatch, SetStateAction } from 'react'
import { createContext, use, useState } from 'react'

export type ThemeCustomizerContextType = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export const ThemeCustomizerContext =
  createContext<ThemeCustomizerContextType | null>(null)

export const useThemeCustomizerContext = () => {
  const context = use(ThemeCustomizerContext)

  if (!context) {
    throw new Error(
      'useThemeCustomizerContext must be used within a ThemeCustomizerContextProvider'
    )
  }

  return context
}

interface ThemeCustomizerContextProviderProps {
  children: React.ReactNode
}

export const ThemeCustomizerContextProvider = ({
  children,
}: ThemeCustomizerContextProviderProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ThemeCustomizerContext value={{ isOpen, setIsOpen }}>
      {children}
    </ThemeCustomizerContext>
  )
}
